import { useState, useCallback } from 'react'
import jsonp from 'jsonp'
import toQueryString from 'to-querystring'

const getAjaxUrl = (url) => url.replace('/post?', '/post-json?')

const useMailchimp = url => {
  const [status, setStatus] = useState(null)
  const [message, setMessage] = useState(null)

  const subscribe = useCallback(
    (data) => {
      const params = toQueryString(data)
      const ajaxUrl = getAjaxUrl(url) + '&' + params
      setStatus('sending')
      setMessage(null)

      jsonp(ajaxUrl, 
        {
          param: 'c',
        },
        (err, data) => {
          console.log('err', err, data)
          if (err) {
            setStatus('error')
            setMessage(err)
          } else if (data.result !== 'success') {
            setStatus('error')
            setMessage(data.msg)
          } else {
            setStatus('success')
            setMessage(data.msg)
          }
        }
      )
    },
    [url]
  )

  return { subscribe, status, message }
}

export default useMailchimp